// Network Configuration
// Change USE_MAINNET to true for production

export const USE_MAINNET = true; // Toggle this for mainnet/testnet

export const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    name: 'BNB Smart Chain',
    rpcUrl: 'https://bsc-dataseed1.binance.org/',
    blockExplorer: 'https://bscscan.com',
    currency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    }
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    name: 'BNB Smart Chain Testnet',
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
    blockExplorer: 'https://testnet.bscscan.com',
    currency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18
    }
  }
};

export const ACTIVE_NETWORK = USE_MAINNET ? NETWORKS.mainnet : NETWORKS.testnet;

export const getNetworkConfig = () => ACTIVE_NETWORK;

export const isCorrectNetwork = (chainId) => {
  return chainId === ACTIVE_NETWORK.chainId || chainId === ACTIVE_NETWORK.chainIdHex;
};
